/**
 * Network utilities for local development
 */

/**
 * Get the current network IP address from the current page URL
 */
 function getNetworkIP() {
  // If we're accessing via network IP, use that IP
  const hostname = window.location.hostname;
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return hostname;
  }
  
  // Fallback to localhost if accessed via localhost
  return 'localhost';
}

/**
 * Replace localhost and 127.0.0.1 in URLs with current network IP
 * Also maps service ports to the home app port (8070) with correct proxy paths
 * Only works when ENABLE_NETWORK_IP_MODE is true
 */
export function replaceLocalhostWithNetworkIP(url) {
  console.log('Original URL:', url)
  
  // if ENABLE_NETWORK_IP_MODE not enabled we leave url as it is
  if (!window.hkConfigEnvs?.ENABLE_NETWORK_IP_MODE) {
    return url;
  }

  // Only replace localhost/127.0.0.1 URLs
  if (!url || (!url.includes('localhost') && !url.includes('127.0.0.1'))) {
    return url;
  }

  const networkIP = getNetworkIP();
  const currentPort = window.location.port || '8070';
  
  // Service port to proxy path mapping
  const serviceProxyMap = {
    '8130': '/frontdesk',        // Frontdesk service
    '8080': '/admin',            // Admin service  
    '8100': '/booking',          // Booking service
    '8090': '/dashboard',        // Dashboard service
    '8210': '/reports',          // Reports service
    '8160': '/hk-property-management', // Property management
    '8140': '/hk-revenue-management', // Hk-revenue-management - Rate Calendar
    '8310': '/enterprise-config', // Enterprise config
    '8230': '/hk-trainkey',      // Trainkey
    '8260': '/hk-booking',      // Booking web
    '8110': '/hk-find-and-reserve',      // Search and Modify 
    // Add other service mappings as needed
  };
  
  let updatedUrl = url;
  
  // Replace localhost/127.0.0.1 with network IP
  updatedUrl = updatedUrl
    .replace(/localhost/g, networkIP)
    .replace(/127\.0\.0\.1/g, networkIP);
  
  // Check if URL has a port that needs proxy mapping
  const portMatch = updatedUrl.match(/:(\d+)/);
  if (portMatch) {
    const originalPort = portMatch[1];
    const proxyPath = serviceProxyMap[originalPort];
    
    if (proxyPath) {
      updatedUrl = updatedUrl.replace(`:${originalPort}`, `:${currentPort}${proxyPath}`);
    } else {
      updatedUrl = updatedUrl.replace(`:${originalPort}`, `:${currentPort}`);
    }
  }
  
  return updatedUrl;
}